import { faker } from '@faker-js/faker/locale/es';

export const DEFAULT_SEED = 42;

let currentSeed = DEFAULT_SEED;

export function setSeed(seed: number): void {
  currentSeed = seed;
  faker.seed(seed);
}

export function getSeed(): number {
  return currentSeed;
}

export function getSeedFromUrl(): number {
  if (typeof window === 'undefined') return DEFAULT_SEED;
  const params = new URLSearchParams(window.location.search);
  const raw = params.get('seed');
  if (!raw) return DEFAULT_SEED;
  const n = Number(raw);
  return Number.isFinite(n) ? n : DEFAULT_SEED;
}
